var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs-simple"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,class:{ active: item.name == _vm.curTab },style:({
      fontSize: _vm.fontSize[_vm.size],
    }),on:{"click":function($event){_vm.curTab = item.name}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }